<div class="d-flex" style="position: relative;">
  <div class="card-body row m-0 align-items-center flex-wrap lc-list-toolbar" style="padding: 24px">
    <div class="input-group form-password-toggle d-flex" style="width: 300px;" *ngIf="showSearch">
      <input
        type="text"
        class="form-control"
        placeholder="Recherche par mot clé"
        aria-label="Recherche"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInput($event)"
      />
      <div class="input-group-append" style="margin-right: 10px;">
        <span class="input-group-text" style="color: black;">
          <i data-feather="search" [size]="20"></i>
        </span>
      </div>
    </div>

    <ng-content></ng-content>

    <button
      *ngIf="primaryLabel"
      type="button"
      class="btn btn-primary ml-auto"
      (click)="onPrimary()"
      rippleEffect
    >
      {{ primaryLabel }}
    </button>
  </div>
</div>
